import { render, staticRenderFns } from "./TogglePlusMinus.vue?vue&type=template&id=2d9c8a19&scoped=true"
import script from "./TogglePlusMinus.vue?vue&type=script&lang=js"
export * from "./TogglePlusMinus.vue?vue&type=script&lang=js"
import style0 from "./TogglePlusMinus.vue?vue&type=style&index=0&id=2d9c8a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c8a19",
  null
  
)

export default component.exports